<template>
  <v-app class="homeView">
    <div class="aParent">
      <div class="polish-logo">
        <div>
          <img
            src="../landing_page/assets/img/godlo.png"
            alt="Godło Rzeczypospolitej Polskiej"
          />
        </div>
        <div style="margin-left: 15px; vertical-align: bottom">
          <h1>Ministerstwo</h1>
          <h1>Spraw Zagranicznych</h1>
        </div>
      </div>
      <AccessibilityToolbar />
    </div>

    <div class="main-menu">
      <v-container>
        <v-layout wrap>
          <v-flex xs12 style="text-align: center">
            <h1>eGranty</h1>
          </v-flex>
          <v-flex xs6>
            <div class="text-xs-center">
              <v-btn
                to="/register/register_bidder"
                color="primary"
                class="register"
              >
                Rejestracja<br />oferentów
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="text-xs-center">
              <v-btn to="/search" color="blue" class="find">
                Znajdź<br />organizację
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="text-xs-center">
              <v-btn
                to="/register/register_volunteer"
                color="blue"
                class="register2"
              >
                Rejestracja<br />wolontariuszy
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="text-xs-center">
              <v-btn :href="loginUrl" color="primary" class="login">
                Logowanie
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <contest-table></contest-table>
  </v-app>
</template>

<script>
import ContestTable from './components/ContestTable';
import AccessibilityToolbar from '../../view/components/AccesibilityToolbar';
import Vue from "vue";

export default {
  name: 'HomeView',
  components: { ContestTable, AccessibilityToolbar },

  metaInfo() {
    return {
      title: "eGranty - Strona główna - Ministerstwo Spraw Zagranicznych",
      meta: [
        { name: 'description', content: 'Aplikacja eGranty. Generator ofert w konkursach MSZ.' },
        { property: 'og:title', content: 'eGranty - Strona główna - Ministerstwo Spraw Zagranicznych' },
        { property: 'og:site_name', content: 'eGranty' },
        { property: 'og:description', content: 'Aplikacja eGranty. Generator ofert w konkursach MSZ.' },
        { property: 'og:type', content: 'website' },
        { property: 'robots', content: 'nosnippet' },
      ]
    };
  },

  data() {
    return {
      attach: '',
    };
  },
  computed: {
    loginUrl() {
      return Vue.prototype.$keycloak ? Vue.prototype.$keycloak.createLoginUrl({ redirectUri: process.env.VUE_APP_APP_URL + "/app/main" }) : null;
    }
  }
};


</script>

<style scoped lang="css">
@import "./assets/css/HomeView.css";

.aParent {
  display: flex;
  justify-content: space-between;
}

.aParent div {
  float: left;
  clear: none;
}

.layout.wrap .theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  margin-bottom: 0;
}

.theme--dark .layout.wrap {
  border: none;
}
</style>
